import "./importFont.css";

//colors
export const colors = {
    gray: "#A9A9A9",
    mercury: "#E8E8E8",
    tundora: "#4E4E4E",
    lightGray: "#EAEAEA",
    darkGray: "#303030",
    white: "#FFFFFF",
    orange: "#FF7B28",
    green: "#00A59E",
    lightOrange: "#FFC7A3"
};

//fonts
export const fonts = {
    roboto: "'Roboto', sans-serif",
    poppins: "'Poppins', 'sans-serif'"
};

//font-sizes
export const fontSizes = {
    font10: "10px",
    font11: "11px",
    font12: "12px",
    font14: "14px",
    font16: "16px",
    font18: "18px",
    font20: "20px",
    font21: "21px",
    font30: "30px",
    font24: "24px"
};

//theme
export const theme = {
    colorPrimary: colors.orange,
    colorSecondary: colors.green,
    colorWhite: colors.white,
    fontPrimary: fonts.poppins
};

export const breakpoints = {
    desktop: "1024px",
    tablet: "720px",
    mobile: "520px"
};
